










































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { actionsEvent } from '@/setup';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchMS } from './fetchMS';
//import modalCREARDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/modal_crear_detalle_alta.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { Console } from 'console';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    MantenedorGridSinCodigo,
    'app-confirmacion': Confirmation,
  },
})
export default class modalVerDetalleSAV extends Vue {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.SolicitudAnulacionVentaGRILLA;
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) ID_SAV_SELECCIONADA: any;
  @Prop({ default: null }) NDV_SELECCIONADA: any;
  //@Prop({ default: null }) GRILA_DETALLE_NDV: any;
  //@Prop({ default: null }) tabs: any;

  GRILA_DETALLE_NDV: any = null;
  tabs: any = null;
  model_nombre_SAV: any = null;
  model_fecha_creacion: any = null;
  model_fecha_registro: any = null;
  model_nombre_nota_venta: any = null;
  model_nombre_factura: any = null;
  model_propietario: any = null;
  model_rut_cliente: any = null;
  model_razon_social: any = null;
  model_tipo_anulacion: any = null;
  model_motivo_anulacion: any = null;
  model_observaciones: any = null;
  model_numero_equipos: any = null;
  model_monto: any = null;
  model_estado: any = null;
  model_razon_estado: any = null;
  model_numero_movimiento: any = null;
  gridApi: GridApi = null;

  accionesTotales: PermisoAccion[] = [];

  constructor() {
    super();
  }
  handleInfoGeneral() {
    this.showInfo = true;
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'EPC',
        field: 'EPC',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Producto',
        field: 'Producto',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Producto EP',
        field: 'Producto EP',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Serie',
        field: 'Serie',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'Plataforma',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo de Flota',
        field: 'Tipo de Flota',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Flota',
        field: 'Flota',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Oportunidad',
        field: 'Oportunidad',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cotización',
        field: 'Cotización',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nota de Venta',
        field: 'Nota de Venta',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Actividad de Preparación',
        field: 'Actividad de Preparación',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Alta de Servicio',
        field: 'Alta de Servicio',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Anulación de Venta',
        field: 'Anulación de Venta',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Modalidad de Venta',
        field: 'Modalidad de Venta',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'Estado',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Razón de Estado',
        field: 'Razón de Estado',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
    ].map(x => ({
      width: 300,
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 30,
    onGridReady: this.handleGridReady,
  };

  async handleGridReady(event: GridReadyEvent) {
    console.log('handleGridReady', this.GRILA_DETALLE_NDV);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.GRILA_DETALLE_NDV);
    this.gridApi.setDomLayout('autoHeight');
  }

  async mounted() {
    console.log('onDialogChanged');
    console.log('abro modal ver detalle SAV', this.ID_SAV_SELECCIONADA);
    let res = await this.get_cabezera_SAV();
  }

  async get_cabezera_SAV() {
    this.loadingService.showLoading(undefined, 'get_SAV');
    return fetchMS(
      {
        id_dav: this.ID_SAV_SELECCIONADA,
        nombre_nota_venta: this.NDV_SELECCIONADA,
      },
      'inicio'
    )
      .then((data: any) => {
        console.log(data.data);
        let cab = data.data.data.LISTA[0];
        this.GRILA_DETALLE_NDV = data.data.DETALLE.LISTA;
        this.loadingService.hideLoading('get_SAV');

        this.model_nombre_SAV = cab['Nombre SAV'];
        this.model_fecha_creacion = cab['Fecha de Creación'];
        this.model_fecha_registro = cab['Fecha de Registro'];
        this.model_nombre_nota_venta = cab['Nombre de Nota de Venta'];
        this.model_nombre_factura = cab['Nombre de Factura'];
        this.model_propietario = cab['Propietario'];
        this.model_rut_cliente = cab['RUT del Cliente'];
        this.model_razon_social = cab['Razón Social'];
        this.model_tipo_anulacion = cab['Tipo de Anulación'];
        this.model_motivo_anulacion = cab['Motivo de Anulación'];
        this.model_observaciones = cab['Observaciones'];
        this.model_numero_equipos = cab['Número de Equipos'];
        this.model_monto = cab['Monto'];
        this.model_estado = cab['Estado CRM'];
        this.model_razon_estado = cab['Razon Estado CRM'];
        this.model_numero_movimiento = cab['Número de Movimiento'];

        this.gridApi.setRowData(this.GRILA_DETALLE_NDV);
        this.gridApi.setDomLayout('autoHeight');
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(id);
    return id;
  }

  closeModal() {
    console.log('closeModal Ver detalle');
    this.$emit('modalverDetalleEmit', false);
  }

  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }
}
